export default __webpack_public_path__ + "static/karrot_logo_jp-8c0bd98d57b141ce5db04bfd35a008ac.svg";